// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const ToggleButton = ({ onToggle, buttonRef }) => (
  <IconButton onClick={onToggle} ref={buttonRef}>
    <VisibilityOff />
  </IconButton>
);

ToggleButton.propTypes = {
  onToggle: PropTypes.func.isRequired,
  buttonRef: PropTypes.func.isRequired
};

export default ToggleButton;